import { TextColors } from '@picsart/design-system/foundation/colors';

import { Spacings } from '@picsart/design-system/foundation/spacings';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles(
  {
    root: {
      color: TextColors.base,
    },

    description: {
      marginBottom: Spacings.s48,
    },
  },
  {
    name: 'title-with-description',
  },
);

export default useStyles;
